// src/features/auth/components/Login/index.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../../api/axiosInstance';
import { clientLogin as clientLoginApi } from '../../../../api';
import styles from './Login.module.css';
import { useAuth } from '../../context/AuthContext';

function Login() {
  const [tab, setTab] = useState('staff');

  // كادر
  const [username, setUsername] = useState('');
  const [staffPassword, setStaffPassword] = useState('');

  // زبون
  const [phone, setPhone] = useState('');
  const [clientPassword, setClientPassword] = useState('');

  const [error,   setError]   = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { login, clientLogin } = useAuth();

  const handleStaffSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/token/', { username, password: staffPassword });
      const { user, access, refresh } = data;
      localStorage.setItem('access_token',  access);
      localStorage.setItem('refresh_token', refresh);
      login(user, { access, refresh });
      navigate('/');
    } catch (err) {
      setError('اسم المستخدم أو كلمة المرور غير صحيحة.');
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
    } finally {
      setLoading(false);
    }
  };

  const handleClientSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await clientLoginApi(phone, clientPassword);
      const { token, client } = res.data;
      clientLogin(client, token);
      navigate('/my-bookings');
    } catch (err) {
      const msg = err.response?.data?.non_field_errors?.[0]
        || err.response?.data?.detail
        || err.response?.data?.error
        || 'رقم الهاتف أو كلمة المرور غير صحيحة.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginBox}>

        {/* التبويبان */}
        <div className={styles.tabs}>
          <button
            type="button"
            className={tab === 'staff' ? styles.tabActive : styles.tab}
            onClick={() => { setTab('staff'); setError(''); }}
          >
            👤 كادر / موظف
          </button>
          <button
            type="button"
            className={tab === 'client' ? styles.tabActive : styles.tab}
            onClick={() => { setTab('client'); setError(''); }}
          >
            📱 زبون / عميل
          </button>
        </div>

        <h2>{tab === 'staff' ? 'دخول الكادر' : 'بوابة العملاء'}</h2>

        {error && <p className={styles.errorMessage}>{error}</p>}

        {/* فورم الكادر */}
        {tab === 'staff' && (
          <form onSubmit={handleStaffSubmit} className={styles.loginForm}>
            <input
              type="text"
              placeholder="اسم المستخدم"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
            />
            <input
              type="password"
              placeholder="كلمة المرور"
              value={staffPassword}
              onChange={(e) => setStaffPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
            <button type="submit" disabled={loading}>
              {loading ? 'جاري الدخول...' : 'تسجيل الدخول'}
            </button>
          </form>
        )}

        {/* فورم الزبون */}
        {tab === 'client' && (
          <form onSubmit={handleClientSubmit} className={styles.loginForm}>
            <input
              type="tel"
              placeholder="07xxxxxxxxx"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              autoComplete="tel"
              dir="ltr"
            />
            <input
              type="password"
              placeholder="كلمة المرور"
              value={clientPassword}
              onChange={(e) => setClientPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
            <button type="submit" disabled={loading}>
              {loading ? 'جاري الدخول...' : 'تسجيل الدخول'}
            </button>
          </form>
        )}

      </div>
    </div>
  );
}

export default Login;
